import { makeStyles, Theme, createStyles, ToolbarProps } from "@material-ui/core";
import { Fragment } from "react";
import { observer } from "mobx-react";
import { Delete } from "mdi-material-ui";
import TableToolbar from "../../../../Shared/Table/TableToolbar";
import REMButton from "../../../../../shared/modules/rem-conversion/components/Button";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        actionButton: {
            color: theme.palette.action.active
        },
    }),
);

interface AdministratorsOverviewSelectionMenuProps extends ToolbarProps {
    numSelections: number;
    onDeleteClicked: () => void;
    onClearSelections: () => void;
}

const AdministratorsOverviewSelectionMenu = observer((props: AdministratorsOverviewSelectionMenuProps) => {

    const classes = useStyles();

    /********* Render *********/

    return (
        <TableToolbar
            leftButtons={
                <Fragment>
                    {props.numSelections > 0 &&
                        <REMButton
                            startIcon={<Delete />}
                            variant="outlined"
                            size="large"
                            onClick={props.onDeleteClicked}
                            className={classes.actionButton}
                        >
                            Delete
                        </REMButton>
                    }
                </Fragment>
            }
            SelectionIndicatorProps={{
                numSelected: props.numSelections,
                onClearSelections: props.onClearSelections
            }}
            {...props}
        />
    );
});

export default AdministratorsOverviewSelectionMenu;